import { combineReducers } from 'redux'
import FeedItemsStore from './stores/feed-items/feed-items.reducer.js'
import WorkUploadStore from './stores/work-upload/work-upload.reducer'

const Reducer = combineReducers({
  FeedItemsStore,
  WorkUploadStore
})

export default Reducer
